export const PRODUCTION_HOSTNAME = 'https://start.profidiet.com'
export const DEVELOPMENT_HOSTNAME = 'http://dev-client:3000'

export const USER_GROUPS = [
  'dd_panel_main_users',
  'dd_panel_restricted_users',
  'dd_panel_users',
  'pd3_users'
]